export default __webpack_public_path__ + "static/media/profile.2d72a3c4.svg";